
export const GET_VOLUNTEERS_SUCCESS = 'GET_VOLUNTEERS_SUCCESS';
export const GET_VOLUNTEERS_FAILURE = 'GET_VOLUNTEERS_FAILURE';

export const POST_VOLUNTEERS_SUCCESS = 'POST_VOLUNTEERS_SUCCESS';
export const POST_VOLUNTEERS_FAILURE = 'POST_VOLUNTEERS_FAILURE';
